<template>
    <main>
        <div class="modal fade" id="modalPartograma" tabindex="-1" aria-labelledby="tituloModalPartograma"
            aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tituloModalPartograma">Registrar control</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Fecha <small class="text-danger">*</small></label>
                                <input v-model="control.fecha" class="form-control form-control-sm" type="date"
                                       :class="{'is-invalid': $v.control.fecha.$error}">
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Hora <small class="text-danger">*</small></label>
                                <input v-model="control.hora" class="form-control form-control-sm" type="time"
                                       :class="{'is-invalid': $v.control.hora.$error}">
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Posición materna</label>
                                <select class="form-control form-control-sm" v-model="control.posicion">
                                    <option value="HORIZONTAL">Horizontal</option>
                                    <option value="VERTICAL">Vertical</option>
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Dilatación (cm) <small class="text-danger">*</small></label>
                                <input v-model.number="control.dilatacion" type="number" step="0.5" min="0" max="10"
                                       class="form-control form-control-sm"
                                       :class="{'is-invalid': $v.control.dilatacion.$error}">
                                <span v-if="$v.control.dilatacion.$error" class="text-danger small">Entre 0 y 10 cm</span>
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Descenso (planos de Hodge)</label>
                                <select class="form-control form-control-sm" v-model="control.descenso">
                                    <option value="">--Seleccione--</option>
                                    <option value="I">I</option>
                                    <option value="II">II</option>
                                    <option value="III">III</option>
                                    <option value="IV">IV</option>
                                </select>
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Variedad de posición</label>
                                <select class="form-control form-control-sm" v-model="control.variedad_posicion">
                                    <option value="">--Seleccione--</option>
                                    <option v-for="v in variedades" :key="v" :value="v">{{ v }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Membranas</label>
                                <select class="form-control form-control-sm" v-model="control.membranas">
                                    <option value="">--Seleccione--</option>
                                    <option value="INTEGRAS">Íntegras</option>
                                    <option value="ROTAS">Rotas</option>
                                </select>
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Líquido amniótico</label>
                                <select class="form-control form-control-sm" v-model="control.liquido_amniotico"
                                        :disabled="control.membranas !== 'ROTAS'">
                                    <option value="">--Seleccione--</option>
                                    <option value="CLARO">Claro</option>
                                    <option value="MECONIADO">Meconiado</option>
                                    <option value="SANGUINOLENTO">Sanguinolento</option>
                                    <option value="FETIDO">Fétido</option>
                                </select>
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Frecuencia cardiaca fetal (lpm)</label>
                                <input v-model.number="control.frecuencia_fetal" type="number" min="60" max="220"
                                       class="form-control form-control-sm"
                                       :class="{'is-invalid': $v.control.frecuencia_fetal.$error}">
                                <span v-if="$v.control.frecuencia_fetal.$error" class="text-danger small">Entre 60 y 220</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Tensión arterial (mmHg)</label>
                                <div class="d-flex">
                                    <input v-model.number="control.ta_sistolica" type="number" placeholder="Sistólica"
                                           class="form-control form-control-sm mr-1">
                                    <input v-model.number="control.ta_diastolica" type="number" placeholder="Diastólica"
                                           class="form-control form-control-sm">
                                </div>
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Pulso materno (lpm)</label>
                                <input v-model.number="control.pulso" type="number" min="20" max="250"
                                       class="form-control form-control-sm">
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Contracciones</label>
                                <div class="d-flex">
                                    <input v-model.number="control.frecuencia_contracciones" type="number" min="0" max="10"
                                           placeholder="N° en 10 min" class="form-control form-control-sm mr-1">
                                    <input v-model.number="control.duracion_contracciones" type="number" min="0" max="180"
                                           placeholder="Duración (seg)" class="form-control form-control-sm">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Dolor (localización)</label>
                                <select class="form-control form-control-sm" v-model="control.dolor_localizacion">
                                    <option value="">--Seleccione--</option>
                                    <option value="SUPRAPUBICO">Suprapúbico (SP)</option>
                                    <option value="SACRO">Sacro (S)</option>
                                    <option value="SUPRAPUBICO Y SACRO">Suprapúbico y sacro (SP+S)</option>
                                </select>
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Dolor (intensidad)</label>
                                <select class="form-control form-control-sm" v-model="control.dolor_intensidad">
                                    <option value="">--Seleccione--</option>
                                    <option value="LEVE">Leve (+)</option>
                                    <option value="MODERADO">Moderado (++)</option>
                                    <option value="INTENSO">Intenso (+++)</option>
                                </select>
                            </div>
                            <div class="col-lg-4 form-group">
                                <label class="small mb-1 font-weight-bolder">Observaciones</label>
                                <input v-model="control.observaciones" maxlength="200" class="form-control form-control-sm">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">
                            <i class="fas fa-times fa-fw"></i> Cerrar
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" :disabled="guardando" @click="guardar()">
                            <i class="fas fa-save fa-fw"></i> {{ guardando ? 'Guardando…' : 'Guardar control' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
/* global $ */
import { required, minValue, maxValue, between } from 'vuelidate/lib/validators';
import partogramaService from "../../../../services/partogramaService";
import Toast from '../../../../components/common/utilities/toast';

const controlVacio = () => ({
    fecha: new Date().toISOString().slice(0, 10),
    hora: new Date().toTimeString().slice(0, 5),
    posicion: 'HORIZONTAL',
    dilatacion: '',
    descenso: '',
    variedad_posicion: '',
    membranas: '',
    liquido_amniotico: '',
    frecuencia_fetal: '',
    ta_sistolica: '',
    ta_diastolica: '',
    pulso: '',
    frecuencia_contracciones: '',
    duracion_contracciones: '',
    dolor_localizacion: '',
    dolor_intensidad: '',
    observaciones: '',
});

export default {
    name: 'ModalPartograma',
    props: {
        idPartograma: { type: [Number, String], required: true },
    },
    data() {
        return {
            control: controlVacio(),
            guardando: false,
            variedades: ['OIIA', 'OIIT', 'OIIP', 'OIDA', 'OIDT', 'OIDP', 'OP', 'OS'],
        };
    },
    validations: {
        control: {
            fecha: { required },
            hora: { required },
            dilatacion: { required, minValue: minValue(0), maxValue: maxValue(10) },
            frecuencia_fetal: { between: between(60, 220) },
        },
    },
    methods: {
        async guardar() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.guardando = true;
            try {
                const datos = { ...this.control, fecha: `${this.control.fecha} ${this.control.hora}` };
                delete datos.hora;
                Object.keys(datos).forEach(k => { if (datos[k] === '') delete datos[k]; });

                const { data } = await partogramaService.storeControl(this.idPartograma, datos);

                this.control = controlVacio();
                this.$v.$reset();
                $('#modalPartograma').modal('hide');
                Toast.fire({ icon: 'success', title: 'Control registrado' });
                this.$emit('guardado', data);
            } catch (e) {
                const respuesta = e.response && e.response.data ? e.response.data : {};
                const errores = respuesta.errors ? Object.values(respuesta.errors).flat() : [];
                Toast.fire({
                    icon: 'error',
                    title: errores.length ? errores[0] : (respuesta.msg || 'No se pudo registrar el control'),
                });
            } finally {
                this.guardando = false;
            }
        },
    },
};
</script>
